<template>
    <div class="sponsor">
        <h2 class="text-center text-md-start mb-3">Sponsors</h2>
        <div class="overflow-y-auto" style="height: calc(100% - 64px);">
            <div class="sponsor-grid">
                <div class="sponsor-card-wrapper" v-for="(sponsorCard, index) in golfClubData?.sponsors" :key="index"
                    @click="handleCardSelection(sponsorCard)">
                    <SponsorsCard class="sponsor-card h-100" :image="sponsorCard?.imageFile"
                        :logo="`${baseUrl}${sponsorCard?.imageFile}`" :headingText="sponsorCard?.name" />
                </div>
            </div>

            <b-modal v-model="openModal" size="lg" hide-header hide-footer class="winnerAward-modal" no-fade
                :centered="true">
                <img src="../assets/svgs/close.svg" class="close__img cursor-pointer align-self-end"
                    @click="openModal = false" />
                <div class="mt-3">
                    <div class="card-modal-img">
                        <ImageWithFallback :src="selectedCard?.imageFile"
                            class="object-fit-contain h-100 comunityCard__img" />
                        <div class="d-flex align-items-center mb-2" v-if="$route.name == 'sponsors'">
                        </div>
                    </div>
                    <BCardTitle class="font-weight-bold comunityCard__title mt-3">{{ selectedCard?.name }}</BCardTitle>
                    <BCardText class="comunityCard__description mb-2">
                        {{ selectedCard?.extra }}
                    </BCardText>
                </div>
            </b-modal>
        </div>
    </div>
</template>

<script>
import SponsorsCard from "@/components/SponsorsCards.vue";
import ImageWithFallback from "@/components/ImageWithFallback.vue";
import CommunityCard from "@/components/CommunityCard.vue";

export default {
    components: {
        SponsorsCard,
        CommunityCard,
        ImageWithFallback,
    },
    data() {
        return {
            selectedCard: null,
            openModal: false,
        };
    },
    watch: {
        golfClubData: {
            handler(newData) {
                if (
                    newData &&
                    newData.sponsors &&
                    newData.sponsors.length > 0
                ) {
                    this.selectedCard = newData.sponsors[0];
                } else {
                    this.selectedCard = null;
                }
            },
        },
    },
    methods: {
        handleCardSelection(card) {
            this.selectedCard = card;
            this.openModal = true;
        },
    },

    mounted() {
        if (
            this.golfClubData &&
            this.golfClubData.sponsors &&
            this.golfClubData.sponsors.length > 0
        ) {
            this.selectedCard = this.golfClubData?.sponsors[0];
        }
    },
};
</script>

<style lang="scss">
.fixed-comunity-card {
    position: fixed !important;
    width: 400px !important;

    @media screen and (min-width: 2560px) and (max-width: 5000px) {
        width: 25% !important;
        height: auto !important;
    }
}

.card-modal-img {
    img {
        max-height: 300px;
    }
}

.sponsor-grid {
    display: grid;
    gap: 1rem;
    justify-content: center;

    grid-template-columns: repeat(2, 1fr);

    @media (min-width: 576px) {
        grid-template-columns: repeat(2, 1fr);
    }

    @media (min-width: 970px) {
        grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
    }
}

.sponsor-card-wrapper {
    width: 100%;
    justify-self: center;

    @media (min-width: 575px) {
        aspect-ratio: 1 / 1;
    }
}
</style>